<template>
    <navigation-menu-list
        :collapsed="collapsed"
        :mobile="mobile"
    ></navigation-menu-list>
</template>

<script>
import NavigationMenuList from "@/components/layout/shared/navigation-menu-list";

export default {
    name: "customer-menu-list",
    components: {NavigationMenuList},
    props: {
        mobile: {
            type: Boolean,
            required: false,
            default: false,
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false,
        }
    }
}
</script>
